module.exports = __webpack_public_path__ + "img/81.4.NH3-N.b0f8b30e.png";